/** Campaign length and guarantee window, shared by Worker and Convex. */
export const PROGRAM_DAYS = 90;
export const PROGRAM_DURATION_MS = PROGRAM_DAYS * 24 * 60 * 60 * 1000;
